import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { SharedService } from '../../shared/shared.service';
import { EventEmitter } from 'protractor';

@Injectable()
export class NewService {

  constructor(private _http: HttpClient) { }

  getPosts(page) {
    return this._http.post(`${environment.api_server}/api/module/blog/get/all`, { page })
  }

  getPostById(_id) {
    return this._http.post(`${environment.api_server}/api/module/blog/get/id`, { _id })
  }

  searchPost(search, page) {
    return this._http.post(`${environment.api_server}/api/module/blog/get/search`, { search, page }, { headers: SharedService.header })
  }

  getDiagrams() {
    return this._http.get(`${environment.api_server}/api/diagrama/all/componentes`, { headers: SharedService.header })
  }
}
